import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyComment } from "@/types";

/**
 * This hook is used to update a company comment in the company comments query
 * without refetching the entire query.
 */
export const useSetCompanyComment = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({
    companyCommentToUpdate,
  }: {
    companyCommentToUpdate: CompanyComment;
  }) => {
    queryClient.setQueryData(
      ["company-comments", currentCompanyId],
      (cachedData: CompanyComment[]) => {
        return cachedData.map((companyComment) => {
          if (companyComment.id === companyCommentToUpdate.id) {
            return companyCommentToUpdate;
          }
          return companyComment;
        });
      },
    );
  };
};
